<!-- 积分屏蔽规则 -->
<template>
  <div class="shield_rules global-content-flex">
    <y-tip>
      <div class="tips_line">1.若设置了屏蔽规则，则优先执行屏蔽规则，满足任意一个屏蔽规则的订单，整个订单将不送积分（基准积分和奖励积分）</div>
      <div class="tips_line">
        2.屏蔽奖励规则之间为或的关系，满足规则条件屏蔽此订单
      </div>
      <div class="tips_line">
        3.规则里面的条件为且的规则，只有所有条件都满足，才表示当前规则符合屏蔽
      </div>
    </y-tip>
    <y-form
      :form-info="formInfo"
      @search="getSearch"
      style="margin-top: 16px"
    ></y-form>
    <div style="margin: 16px 0">
      <y-button @click="createRules">新建规则</y-button>
    </div>
    <div class="global-felx-1">
      <y-table
        :tableInfo="tableInfo"
        :pageInfo="{
          pageNum: pageInfo.pageNum,
          pageSize: pageInfo.pageSize,
          total: pageInfo.total,
        }"
        :tableData="tableData"
        :loading="talbeLoading"
        @handlePage="handlePage"
      >
        <template #ruleStatus="scope">
          <el-switch
            v-model="scope.row.ruleStatus"
            @change="swicthChange($event, scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
        <template #operate="scope">
          <y-button type="blueText" @click="handleEdit(scope.row)">编辑</y-button>
          <y-button type="blueText" @click="handleDel(scope.row)">移除</y-button>
        </template>
      </y-table>
    </div>
    <y-dialog
      title="提示"
      :visible.sync="sureDialogVisible"
      width="452px"
      top="40vh"
      @comfirm="deleteConfirm"
      @close="sureDialogVisible = false"
    >
      <y-tip type="gley-empty">
        <span>确定要删除该基础积分规则?</span>
      </y-tip>
    </y-dialog>

    <!-- 新建积分屏蔽规则弹窗 -->
    <point-shield-rule
      v-if="createRuleShow"
      :visible="createRuleShow"
      :rowData="rowData"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import dateTime from "@/components/form/date-range";
import pointShieldRule from "@/components/point-shield-rule.vue";
import {
  rewardRuleList,
  rewardRuleDelete,
  rewardRuleUpdateStatus,
} from "@/api/integralCenter/newMemberSystem";
export default {
  components: {
    dateTime,
    pointShieldRule,
  },
  data() {
    return {
      MemberSystemInfo: {}, // 会员体系信息
      form: {
        ruleName: "",
        ruleStatus: "",
        upDateStart: "",
        upDateEnd: "",
        ruleType: 2, // 1奖励 2屏蔽
      },
      talbeLoading: false,
      tableData: [],
      pageInfo: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      createRuleShow: false, // 新建积分奖励规则弹窗
      sureDialogVisible: false, // 删除确认框
      rowData: {},

      formInfo: [
        {
          label: "规则名称：",
          prop: "ruleName",
          type: "Input",
          placeholder: "请输入名称",
        },
        {
          label: "是否启用：",
          prop: "ruleStatus",
          type: "Select",
          value: "",
          options: [
            {
              value: "",
              label: "不限",
            },
            {
              value: 1,
              label: "启用",
            },
            {
              value: 0,
              label: "关闭",
            },
          ],
        },
        {
          label: "最新更新时间：",
          prop: "time",
          type: "DateRange",
          dateType: "datetime",
          startKey: "upDateStart",
          endKey: "upDateEnd",
        },
      ],
      tableInfo: [
        {
          label: "规则名称",
          prop: "ruleName",
        },
        {
          label: "最新更新时间",
          prop: "lastUpdateTime",
        },
        {
          label: "是否启用",
          prop: "ruleStatus",
          slot: "ruleStatus",
        },
        {
          label: "操作",
          prop: "operate",
          slot: "operate",
        },
      ],
    };
  },
  created() {
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
  },
  mounted() {
    this.search(1);
  },
  methods: {
    getSearch(obj) {
      console.log("obj", obj);
      for (const key in obj) {
        this.form[key] = obj[key];
      }
      this.pageInfo.pageNum = 1;
      this.pageInfo.pageSize = 10;
      this.search(1);
    },
    // 查询
    search(type) {
      if (type == 0) {
        this.form = {
          ruleName: "",
          ruleStatus: "",
          upDateStart: "",
          upDateEnd: "",
          ruleType: 2,
        };
        this.pageInfo = {
          pageSize: 10,
          pageNum: 1,
        };
      }
      let obj = {
        ...this.form,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        cardId: this.MemberSystemInfo.scoresCardId,
      };
      this.talbeLoading = true;
      rewardRuleList(obj)
        .then((res) => {
          this.tableData = res.data.dataList;
          this.pageInfo.total = res.data.pageInfo.total;
          this.talbeLoading = false;
        })
        .catch(() => {
          this.talbeLoading = false;
        });
    },
    // 切换启用状态
    swicthChange(val, row) {
      console.log(val, row);
      let obj = {
        ruleId: row.scoresRewardRuleId,
        status: val,
      };
      rewardRuleUpdateStatus(obj).then((res) => {
        this.$message.success("开启成功");
        this.search(1);
      });
    },
    // 新建规则
    createRules() {
      this.rowData = {};
      this.createRuleShow = true;
    },
    // 编辑规则
    handleEdit(row) {
      this.rowData = row;
      this.createRuleShow = true;
    },
    closeDialog(val) {
      this.createRuleShow = false;
      if (val) this.search(1);
    },
    // 删除规则
    handleDel(row) {
      if (row.ruleStatus) return this.$message.warning("不可删除已启用的规则");
      this.sureDialogVisible = true;
      this.rowData = row;
    },
    // 确认删除
    deleteConfirm() {
      rewardRuleDelete({ ruleId: this.rowData.scoresRewardRuleId })
        .then((res) => {
          this.$message.success("删除成功!");
          this.sureDialogVisible = false;
          this.search(1);
        })
        .catch(() => {
          this.sureDialogVisible = false;
        });
    },

    handlePage(val) {
      this.pageInfo.pageNum = val.pageNum;
      this.pageInfo.pageSize = val.pageSize;
      this.search(1);
    },
    // 分页-first
    // handleSizeChange(val) {
    //   this.pageInfo.pageSize = val;
    //   this.search(1);
    // },
    // handleCurrentChange(val) {
    //   this.pageInfo.pageNum = val;
    //   this.search(1);
    // },
  },
};
</script>

<style lang="scss" scoped>
.shield_rules{
  height: 100%;
}
</style>